<template>
  <div>
    <div id="navbar" class="navbar d-flex justify-space-between align-center">
      <div class="_left">
        <div class="logo" @click="toPage('/m')">
          <img src="@/assets/mobile/logo.png" />
        </div>
      </div>
      <div class="_right">
        <div class="menu" @click="open = !open" :class="{ active: open }">
          <div class="line"></div>
          <div class="line"></div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div class="dropdown-menu" :class="{ active: open }">
      <a class="item" @click="toPage('/mhowHeart')">Why Heart Smart™</a>
      <a class="item" @click="toPage('/mhowWork')">How Heart Smart™ Works</a>
      <a class="item" @click="toPage('/msupport')">Contact Us</a>
    </div>
    <div class="place"></div>
  </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      open: false
    };
  },
  methods: {
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    toPage(path) {
      this.$router.push(path)
    }
  }
};
</script>

<style lang="less" scoped>
.navbar {
  width: 100%;
  min-height: 1rem;
  padding: 0 0.34rem 0 0.29rem;
  position: fixed;
  top: 0;
  background: #fff;
  box-shadow: 0px 0px 4px #efefef;
  z-index: 999;
  font-size: 0;
  .logo {
    img {
      width: 2.38rem;
    }
  }
  .menu {
    .line {
      width: 0.35rem;
      height: 0.04rem;
      margin-bottom: 0.08rem;
      background: #50c88c;
      transition: all 0.3s ease-in-out;
    }
    &.active {
      .line:nth-child(1) {
        transform: rotate(-45deg) translate(-0.06rem, 0.13rem);
      }
      .line:nth-child(2) {
        opacity: 0;
      }
      .line:nth-child(3) {
        transform: rotate(45deg) translate(-0.04rem, -0.1rem);
      }
    }
  }
}
.dropdown-menu {
  width: 100%;
  height: 100vh;
  padding: 1.67rem 0.77rem 0.77rem 0.77rem;
  position: fixed;
  top: 0;
  background: #eae9ea;
  z-index: 998;
  transition: all 0.3s ease-in-out;
  transform: translate(0, -100vh);
  opacity: 0;
  &.active {
    transform: translate(0, 0);
    opacity: 1;
  }
  .item {
    display: block;
    color: #373536;
    font-size: 0.48rem;
    padding: 0.56rem 0;
    border-bottom: 1px solid #50c88c;
    &.item:last-child {
      border: none;
    }
  }
}
.place{
  width: 100%;
  min-height: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/components/navbar.vue